import './storage';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Detecta nova versão do build e força reload automático.
// O CRA injeta %REACT_APP_VERSION% via .env ou usa a data do build como fallback.
const BUILD_KEY = 'agpro_build';
const BUILD_ID = process.env.REACT_APP_BUILD_ID || process.env.REACT_APP_VERSION || '__DEV__';
const stored = localStorage.getItem(BUILD_KEY);
if (stored && stored !== BUILD_ID && BUILD_ID !== '__DEV__') {
  // Nova versão detectada: limpa cache e recarrega a página
  localStorage.setItem(BUILD_KEY, BUILD_ID);
  window.location.reload(true);
} else {
  localStorage.setItem(BUILD_KEY, BUILD_ID);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
